<template>
  <div class="tw-container tw-m-auto tw-mt-32 md:tw-w-2/3 tw-p-4 tw-w-full">
    <div class="md:tw-text-right tw-font-sans tw-text-center md:tw-text-3xl tw-text-3xl tw-mr-4">
      <h1>{{selectedLanguage == 'US' ? en.title_6 : pt.title_6}}</h1>
    </div>
    <hr class="tw-border-dashed tw-border-sky-700 tw-mt-1">
    <div id="about" class="tw-shadow-md mt-4" v-if="artist.options.bio">
      <div class="background">
        <picture class="tw-w-full tw-h-full tw-object-cover tw-object-center tw-block">
          <source :srcset="pageOptions ? (pageOptions.bio_image ? '/'+pageOptions.bio_image : spotifyArtist.images[0].url) : spotifyArtist.images[0].url">
          <img :src="pageOptions ? (pageOptions.bio_image ? '/'+pageOptions.bio_image : spotifyArtist.images[0].url) : spotifyArtist.images[0].url" class="tw-w-full tw-h-full tw-object-cover tw-object-center tw-block" alt="">
        </picture>
      </div>
      <div class="tw-container tw-mx-auto tw-relative">
        <div class="tw-w-full md:tw-w-6/12 tw-py-16 tw-px-8 md:tw-px-4">
          <img :src="artist.post_image" v-if="artist.post_image" class="tw-w-24 tw-mb-8 tw-mx-auto md:tw-m-0" alt="">
          <div class="tw-flex tw-items-center tw-mb-6 tw-mt-3 tw-space-x-5 tw-justify-center md:tw-justify-start">
            <a target="_blank" :href="'https://www.youtube.com/channel/'+artist.options.youtubeUrl" v-if="artist.options.youtubeUrl && artist.options.youtubeUrl !== '#'" class="hover:tw-opacity-50 tw-transition-all tw-duration-300"><img src="/imgs/youtube-home.png" alt="" class="tw-w-12 md:tw-w-auto" /></a>
            <a target="_blank" :href="'https://open.spotify.com/artist/'+artist.options.spotifyUrl" v-if="artist.options.spotifyUrl && artist.options.spotifyUrl !== '#'" class="hover:tw-opacity-50 tw-transition-all tw-duration-300"><img src="/imgs/spotify-home.png" alt="" class="tw-w-12 md:tw-w-auto" /></a>
          </div>
          <p class="tw-font-sans tw-text-sm tw-text-white tw-font-light tw-leading-loose bio tw-overflow-hidden tw-relative truncated tw-whitespace-pre-wrap" v-html="artist.options.bio"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout2';
import EventBus from '@/eventbus';
import pt from "../../../../../lang/smartsite/layout_2/layout_2.js";

export default {
mixins: [pt],
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
  props: ['artist', 'spotifyArtist', 'pageOptions'],
  data(){
    return{
      snackbar: false,
      snackbar_text: '',
      technical: false,
      technical_free: false,
      technical_password: '',
      press: false,
      press_free: false,
      press_password: '',
    }
  },
  computed: {
    selectedLanguage() {
      return this.$page.props.lang;
    }
  },
  methods: {
    verifyPassword(val){
      axios.post(`/api/presskit/password/${this.pageOptions.id}`, {
        type: val,
        password: val == 'press' ? this.press_password : this.technical_password
      })
      .then(res => {
        if(res.data.password){
          val == 'press' ? this.press_free = true : this.technical_free = true;
        } else {
          this.snackbar = true;
          this.snackbar_text = this.verifyPassword
        }
      });
    },
  },
  created(){
    EventBus.$emit('artist', {'artist': this.artist, 'pageOptions': this.pageOptions});
  },
  mounted() {
    if(this.$page.props.lang == 'US') {
      var open = pt.data().en.open
      var close = pt.data().en.close
    } else {
      var open = pt.data().pt.open
      var close = pt.data().pt.close
    }

    $(document).ready(function () {
      $('#about .bio').readmore({
        moreLink: `<a href="#" class="readmore tw-font-sans tw-text-white tw-text-center tw-block md:tw-text-left">${open}</a>`,
        lessLink: `<a href="#" class="readmore--close tw-text-white tw-font-sans tw-text-center tw-block md:tw-text-left">${close}</a>`,
        collapsedHeight: 100, 
        beforeToggle: function(trigger, el, ex) {
          if(ex){
            $('#artist .bio').addClass('truncated')
            $('#artist .bio').addClass('tw-overflow-hidden')
            $('#artist .bio').removeClass('tw-overflow-y-auto')
            setTimeout( function() {$('#artist .bio').scrollTop(0)}, 200 );;
          } else {
            $('#artist .bio').removeClass('tw-overflow-hidden')
            $('#artist .bio').addClass('tw-overflow-y-auto')
            $('#artist .bio').css({
              'max-height': '400px'
            });
            $('#artist .bio').removeClass('truncated')
          }
        } 
      });
    });
  }
}
</script>

<style>

#about .bio{
  transition: all 0.5s ease 0s;
}
#about .bio.truncated{
  -webkit-mask-image: -webkit-gradient(linear, left 50%, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));
}
#about .bio.truncated::before{
  content: '';
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid #eee;
}
#about{
  position: relative;
  height: auto;
  background-color: #000;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 0.375rem;
  overflow: hidden;
}
#about .bio-height{
  max-height: 200px;
}
#about .background{
  height: 56.25vw;
  margin-bottom: -50px;
  position: relative;
  z-index: 0;
  overflow: hidden;
  background-color: #000;
  top: 0;
  width: 100%;
}
#about .background::before {
  display: block;
  content: "";
  position: absolute;
  width: calc(100% + 1px);
  height: calc(100% + 1px);
  z-index: 1;
  background-image: linear-gradient(180deg,transparent 60%,#000);
}

@media only screen and (min-width: 768px){
  #about{
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    height: auto;
    margin-left: 0;
    margin-right: 0;
    min-height: 33.75vw;
  }
  #about .background{
    position: absolute;
    top: 0;
    right: 0;
    width: 60%;
    height: 100%;
    margin-bottom: 0;
  }
  #about .background::before {
    background-image: linear-gradient(90deg,#000,transparent 40%,transparent);
  }
}
@media only screen and (min-width: 1024px){
  #about{
    min-height: 30.9vw;
  }
  #about .background{
    width: 55%;
  }
}
    
</style>